var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapChevron = function SvgMapChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14 5.996c0-.34-.134-.643-.403-.906L1.887.313A1.042 1.042 0 0 0 1.12 0C.813 0 .55.107.33.321.11.535 0 .796 0 1.104c0 .307.12.579.362.815L4.53 5.988.362 10.073c-.241.236-.362.508-.362.815 0 .308.11.57.33.787.22.217.483.325.79.325.302 0 .557-.107.766-.321l4.851-4.777c.143-.143.246-.287.309-.433.063-.145.095-.303.095-.473Z",
    fill: "#999"
  })));
};

export default SvgMapChevron;